import React from 'react'
import Icon from 'components/Shared/Icon'

interface AuditListItemProps {
  id: string | number
  name: string
  warningLevel: 'warning' | 'error' | 'success'
  warningIcon: string
  warningMessage: string
  onClick: (id: string) => void
  onKeyDown: (e: React.KeyboardEvent, id: string) => void
  additionalContent?: React.ReactNode
}

const AuditListItem: React.FC<AuditListItemProps> = ({
  id,
  name,
  warningLevel,
  warningIcon,
  warningMessage,
  onClick,
  onKeyDown,
  additionalContent,
}) => {
  const handleClick = () => onClick(id.toString())
  const handleKeyDown = (e: React.KeyboardEvent) => onKeyDown(e, id.toString())

  return (
    <div
      role="button"
      tabIndex={0}
      className={`audit-list-item audit-${warningLevel} clickable`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      style={{ cursor: 'pointer' }}
    >
      <div className="audit-item-content">
        <div className="audit-item-header">
          <Icon type={warningIcon} />
          <span className="screen-name">{name}</span>
          {additionalContent}
        </div>
        <p className="audit-message">{warningMessage}</p>
      </div>
    </div>
  )
}

export default React.memo(AuditListItem)
